// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","img":"Loader_img__-sTVW"};